(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2084],{

/***/ 93721:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[appId]/app/line-sticker",
      function () {
        return __webpack_require__(56105);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CopyClipboard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73400);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74855);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41997);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87109);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34386);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93946);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(83321);
/* harmony import */ var _Iconify__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42445);
/* harmony import */ var _hooks_useResponsive__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10653);









function CopyClipboard(param) {
    var value = param.shareInputValue, inputProps = param.inputProps, onShareInputValueChange = param.onShareInputValueChange;
    var isMobile = (0,_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("down", "sm");
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_2__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        value: value,
        copied: false
    }), state = ref[0], setState = ref[1];
    var handleChange = function(event) {
        var newVal = event.target.value;
        setState({
            value: newVal,
            copied: false
        });
        if (onShareInputValueChange) {
            onShareInputValueChange(newVal);
        }
    };
    var onCopy = function() {
        setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
            copied: true
        }));
        if (state.value) {
            enqueueSnackbar("Copied!");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                fullWidth: true,
                multiline: true,
                maxRows: 15,
                value: state.value,
                onChange: handleChange,
                InputProps: {
                    endAdornment: isMobile ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        position: "end",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__.CopyToClipboard, {
                            text: state.value,
                            onCopy: onCopy,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                title: "Copy",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Iconify__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        icon: "eva:copy-fill",
                                        width: 24,
                                        height: 24
                                    })
                                })
                            })
                        })
                    })
                }
            }, inputProps)),
            isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_3__.CopyToClipboard, {
                text: state.value,
                onCopy: onCopy,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    fullWidth: true,
                    variant: "outlined",
                    sx: {
                        mt: 1
                    },
                    children: "Copy to Clipboard"
                })
            })
        ]
    });
}


/***/ }),

/***/ 77645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15861);





var Typewriter = function(param) {
    var input = param.input, renderText = param.renderText, _styleOverPropsForCursor = param.styleOverPropsForCursor, styleOverPropsForCursor = _styleOverPropsForCursor === void 0 ? {} : _styleOverPropsForCursor, _styleOverPropsForText = param.styleOverPropsForText, styleOverPropsForText = _styleOverPropsForText === void 0 ? {} : _styleOverPropsForText, _hideCursor = param.hideCursor, hideCursor = _hideCursor === void 0 ? false : _hideCursor, _speed = param.speed, speed = _speed === void 0 ? 20 : _speed;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), text = ref[0], setText = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), index = ref1[0], setIndex = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), showCursor = ref2[0], setShowCursor = ref2[1];
    var speedForCursor = speed * 25;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timerID = setInterval(function() {
            if (index < input.length) {
                setText(function(prevText) {
                    return prevText + input[index];
                });
                setIndex(function(prevIndex) {
                    return prevIndex + 1;
                });
            } else {
                clearInterval(timerID);
            }
        }, speed);
        return function() {
            return clearInterval(timerID);
        };
    }, [
        input,
        index,
        speed
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timerID = setInterval(function() {
            setShowCursor(function(prevShowCursor) {
                return !prevShowCursor;
            });
        }, speedForCursor);
        return function() {
            return clearInterval(timerID);
        };
    }, [
        speedForCursor
    ]);
    var ref3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                variant: "body2",
                sx: {
                    color: "common.white",
                    whiteSpace: "pre-line"
                }
            }, styleOverPropsForText), {
                children: (ref3 = renderText === null || renderText === void 0 ? void 0 : renderText(text)) !== null && ref3 !== void 0 ? ref3 : text
            })),
            hideCursor ? null : text.length !== input.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, styleOverPropsForCursor), {
                variant: "body2",
                style: {
                    opacity: showCursor ? 1 : 0
                },
                children: "|"
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Typewriter);


/***/ }),

/***/ 98968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aN": function() { return /* binding */ PromptSupportingLanguageMap; }
/* harmony export */ });
/* unused harmony exports ImageCreateResponseFormat, ResponseTone, WritingStyle, PromptInterfaceFragmentDoc, VisitorChromeExtensionPromptResponseFragmentDoc, VisitorChromeExtensionPromptResponseWithPromptDetailFragmentDoc, VisitorFetchPromptsDocument, VisitorFetchPromptsForChromeExtensionDocument, VisitorFetchPromptsForChromeExtensionWithPromptDetailDocument, VisitorGeneratePromptDocument, getSdk */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39011);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31230);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment PromptInterface on PromptInterface {\n    id\n    promptHint\n    promptTeaser\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment VisitorChromeExtensionPromptResponse on ChromeExtensionPromptResponse {\n    id\n    title\n    category\n    promptHint\n    promptTeaser\n    createdAt\n    updatedAt\n    statistics {\n      usages\n      views\n      votes\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment VisitorChromeExtensionPromptResponseWithPromptDetail on ChromeExtensionPromptResponse {\n    ...VisitorChromeExtensionPromptResponse\n    prompt\n  }\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query visitorFetchPrompts @cached(ttl: 300) {\n    prompts {\n      ...PromptInterface\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query visitorFetchPromptsForChromeExtension @cached(ttl: 300) {\n    promptsForChromeExtension {\n      ...VisitorChromeExtensionPromptResponse\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query visitorFetchPromptsForChromeExtensionWithPromptDetail @cached(ttl: 300) {\n    promptsForChromeExtension {\n      ...VisitorChromeExtensionPromptResponseWithPromptDetail\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query visitorGeneratePrompt(\n    $language: PromptSupportingLanguageMap!\n    $prompt: String!\n    $promptId: String!\n  ) {\n    generatePrompt(prompt: $prompt, promptId: $promptId, language: $language) {\n      id\n      language\n      prompt\n      createResponse {\n        created\n        id\n        model\n        object\n        usage {\n          completion_tokens\n          prompt_tokens\n          total_tokens\n        }\n        choices {\n          finish_reason\n          index\n          text\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var ImageCreateResponseFormat;
(function(ImageCreateResponseFormat) {
    ImageCreateResponseFormat["B64Json"] = "b64_json";
    ImageCreateResponseFormat["Url"] = "url";
})(ImageCreateResponseFormat || (ImageCreateResponseFormat = {}));
var PromptSupportingLanguageMap;
(function(PromptSupportingLanguageMap) {
    PromptSupportingLanguageMap["Arabic"] = "Arabic";
    PromptSupportingLanguageMap["Bulgarian"] = "Bulgarian";
    PromptSupportingLanguageMap["Catalan"] = "Catalan";
    PromptSupportingLanguageMap["Chinese"] = "Chinese";
    PromptSupportingLanguageMap["Czech"] = "Czech";
    PromptSupportingLanguageMap["Danish"] = "Danish";
    PromptSupportingLanguageMap["Dutch"] = "Dutch";
    PromptSupportingLanguageMap["English"] = "English";
    PromptSupportingLanguageMap["Finnish"] = "Finnish";
    PromptSupportingLanguageMap["French"] = "French";
    PromptSupportingLanguageMap["German"] = "German";
    PromptSupportingLanguageMap["Greek"] = "Greek";
    PromptSupportingLanguageMap["Hebrew"] = "Hebrew";
    PromptSupportingLanguageMap["Hindi"] = "Hindi";
    PromptSupportingLanguageMap["Hungarian"] = "Hungarian";
    PromptSupportingLanguageMap["Indonesian"] = "Indonesian";
    PromptSupportingLanguageMap["Italian"] = "Italian";
    PromptSupportingLanguageMap["Japanese"] = "Japanese";
    PromptSupportingLanguageMap["Korean"] = "Korean";
    PromptSupportingLanguageMap["MandarinChinese"] = "MandarinChinese";
    PromptSupportingLanguageMap["Norwegian"] = "Norwegian";
    PromptSupportingLanguageMap["Polish"] = "Polish";
    PromptSupportingLanguageMap["Portuguese"] = "Portuguese";
    PromptSupportingLanguageMap["Romanian"] = "Romanian";
    PromptSupportingLanguageMap["Russian"] = "Russian";
    PromptSupportingLanguageMap["Serbian"] = "Serbian";
    PromptSupportingLanguageMap["Spanish"] = "Spanish";
    PromptSupportingLanguageMap["Swedish"] = "Swedish";
    PromptSupportingLanguageMap["Thai"] = "Thai";
    PromptSupportingLanguageMap["Turkish"] = "Turkish";
    PromptSupportingLanguageMap["Ukrainian"] = "Ukrainian";
    PromptSupportingLanguageMap["Vietnamese"] = "Vietnamese";
})(PromptSupportingLanguageMap || (PromptSupportingLanguageMap = {}));
var ResponseTone;
(function(ResponseTone) {
    ResponseTone["Authoritative"] = "Authoritative";
    ResponseTone["Clinical"] = "Clinical";
    ResponseTone["Cold"] = "Cold";
    ResponseTone["Confident"] = "Confident";
    ResponseTone["Cynical"] = "Cynical";
    ResponseTone["Emotional"] = "Emotional";
    ResponseTone["Empathetic"] = "Empathetic";
    ResponseTone["Formal"] = "Formal";
    ResponseTone["Friendly"] = "Friendly";
    ResponseTone["Humorous"] = "Humorous";
    ResponseTone["Informal"] = "Informal";
    ResponseTone["Ironic"] = "Ironic";
    ResponseTone["Label"] = "Label";
    ResponseTone["Optimistic"] = "Optimistic";
    ResponseTone["Pessimistic"] = "Pessimistic";
    ResponseTone["Playful"] = "Playful";
    ResponseTone["Sarcastic"] = "Sarcastic";
    ResponseTone["Serious"] = "Serious";
    ResponseTone["Sympathetic"] = "Sympathetic";
    ResponseTone["Tentative"] = "Tentative";
    ResponseTone["Warm"] = "Warm";
})(ResponseTone || (ResponseTone = {}));
var WritingStyle;
(function(WritingStyle) {
    WritingStyle["Academic"] = "Academic";
    WritingStyle["Analytical"] = "Analytical";
    WritingStyle["Argumentative"] = "Argumentative";
    WritingStyle["Conversational"] = "Conversational";
    WritingStyle["Creative"] = "Creative";
    WritingStyle["Critical"] = "Critical";
    WritingStyle["Descriptive"] = "Descriptive";
    WritingStyle["Epigrammatic"] = "Epigrammatic";
    WritingStyle["Epistolary"] = "Epistolary";
    WritingStyle["Expository"] = "Expository";
    WritingStyle["Informative"] = "Informative";
    WritingStyle["Instructive"] = "Instructive";
    WritingStyle["Journalistic"] = "Journalistic";
    WritingStyle["Label"] = "Label";
    WritingStyle["Metaphorical"] = "Metaphorical";
    WritingStyle["Narrative"] = "Narrative";
    WritingStyle["Persuasive"] = "Persuasive";
    WritingStyle["Poetic"] = "Poetic";
    WritingStyle["Satirical"] = "Satirical";
    WritingStyle["Technical"] = "Technical";
})(WritingStyle || (WritingStyle = {}));
var PromptInterfaceFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject());
var VisitorChromeExtensionPromptResponseFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject1());
var VisitorChromeExtensionPromptResponseWithPromptDetailFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject2(), VisitorChromeExtensionPromptResponseFragmentDoc);
var VisitorFetchPromptsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject3(), PromptInterfaceFragmentDoc);
var VisitorFetchPromptsForChromeExtensionDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject4(), VisitorChromeExtensionPromptResponseFragmentDoc);
var VisitorFetchPromptsForChromeExtensionWithPromptDetailDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject5(), VisitorChromeExtensionPromptResponseWithPromptDetailFragmentDoc);
var VisitorGeneratePromptDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject6());
var defaultWrapper = function(action, _operationName, _operationType) {
    return action();
};
var VisitorFetchPromptsDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__/* .print */ .S)(VisitorFetchPromptsDocument);
var VisitorFetchPromptsForChromeExtensionDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__/* .print */ .S)(VisitorFetchPromptsForChromeExtensionDocument);
var VisitorFetchPromptsForChromeExtensionWithPromptDetailDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__/* .print */ .S)(VisitorFetchPromptsForChromeExtensionWithPromptDetailDocument);
var VisitorGeneratePromptDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__/* .print */ .S)(VisitorGeneratePromptDocument);
function getSdk(client) {
    var withWrapper = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultWrapper;
    return {
        visitorFetchPrompts: function visitorFetchPrompts(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(VisitorFetchPromptsDocumentString, variables, _object_spread({}, requestHeaders, wrappedRequestHeaders));
            }, "visitorFetchPrompts", "query");
        },
        visitorFetchPromptsForChromeExtension: function visitorFetchPromptsForChromeExtension(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(VisitorFetchPromptsForChromeExtensionDocumentString, variables, _object_spread({}, requestHeaders, wrappedRequestHeaders));
            }, "visitorFetchPromptsForChromeExtension", "query");
        },
        visitorFetchPromptsForChromeExtensionWithPromptDetail: function visitorFetchPromptsForChromeExtensionWithPromptDetail(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(VisitorFetchPromptsForChromeExtensionWithPromptDetailDocumentString, variables, _object_spread({}, requestHeaders, wrappedRequestHeaders));
            }, "visitorFetchPromptsForChromeExtensionWithPromptDetail", "query");
        },
        visitorGeneratePrompt: function visitorGeneratePrompt(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(VisitorGeneratePromptDocumentString, variables, _object_spread({}, requestHeaders, wrappedRequestHeaders));
            }, "visitorGeneratePrompt", "query");
        }
    };
}


/***/ }),

/***/ 56105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ LineSticker; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(40549);
/* harmony import */ var _layouts_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72575);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61582);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _theme_palette__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78187);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(66242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(27948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(3180);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(41997);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(83321);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(67720);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(50122);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(36822);
/* harmony import */ var _generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98968);
/* harmony import */ var _mui_lab__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(31812);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var ts_enum_util__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54586);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25168);
/* harmony import */ var _sections_landing_Shares__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29608);
/* harmony import */ var _components_Typewriter__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77645);
/* harmony import */ var _routes_paths__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96259);
/* harmony import */ var _components_CopyClipboard__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50107);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(74855);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(86704);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  min-height: 100vh;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


















// TODO get prompt id from constant propmt
var LINE_STICKER_PROMPT_ID = "line_sticker";
LineSticker.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layouts_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        variant: "main",
        children: page
    });
};
var Character;
(function(Character) {
    Character["Cat"] = "Cat";
    Character["Bear"] = "Bear";
    Character["Rabbit"] = "Rabbit";
    Character["Fox"] = "Fox";
    Character["Girl"] = "Girl";
    Character["Boy"] = "Boy";
    Character["SpongeBob"] = "SpongeBob";
    Character["MickeyMouse"] = "Mickey Mouse";
})(Character || (Character = {}));
var StyledCard = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_templateObject(), _theme_palette__WEBPACK_IMPORTED_MODULE_5__/* .shinyCssWithoutHoverEffect */ .PM);
var __N_SSG = true;
function LineSticker(param) {
    var title = param.title, seoMetadataItemsCollection = param.seoMetadataItemsCollection;
    var ref, ref1, ref2;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .useVisitorGeneratePromptLazyQuery */ .SDW)({
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "no-cache"
    }), 2), visitorGeneratePromptLazyQuery = ref3[0], ref4 = ref3[1], visitorGeneratePromptLazyQueryLoading = ref4.loading, visitorGeneratePromptLazyQueryData = ref4.data;
    var ref5 = (0,_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .useVisitorFetchPromptUsagesQuery */ .DNU)({
        variables: {
            where: {
                promptId: {
                    _eq: LINE_STICKER_PROMPT_ID
                }
            },
            limit: 30
        }
    }), visitorFetchPromptUsagesQuery = ref5.data;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)();
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(""), character = ref6[0], setCharacter = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(null), originTextInputs = ref7[0], setOriginTextInputs = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(null), textInputs = ref8[0], setTextInputs = ref8[1];
    var renderText = (ref1 = (ref = visitorGeneratePromptLazyQueryData === null || visitorGeneratePromptLazyQueryData === void 0 ? void 0 : visitorGeneratePromptLazyQueryData.generatePrompt.createResponse) === null || ref === void 0 ? void 0 : ref.choices[0]) === null || ref1 === void 0 ? void 0 : ref1.text;
    var mergedTextInputs = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function() {
        return textInputs || (renderText === null || renderText === void 0 ? void 0 : renderText.split(/\r?\n|\r|\n/g));
    }, [
        textInputs,
        renderText
    ]);
    var handleGeneratePrompt = function() {
        return visitorGeneratePromptLazyQuery({
            variables: {
                promptId: LINE_STICKER_PROMPT_ID,
                language: _generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_6__/* .PromptSupportingLanguageMap.English */ .aN.English,
                prompt: character
            },
            fetchPolicy: "no-cache"
        }).then(function() {
            setTextInputs(null);
            setOriginTextInputs(null);
        });
    };
    var ref9;
    var promptUsages = (ref9 = visitorFetchPromptUsagesQuery === null || visitorFetchPromptUsagesQuery === void 0 ? void 0 : visitorFetchPromptUsagesQuery.promptUsages) !== null && ref9 !== void 0 ? ref9 : [];
    var handleOpenMidjourneyBotChannel = function() {
        router.replace(_config__WEBPACK_IMPORTED_MODULE_15__/* .DISCORD.linkToApp */ .qs.linkToApp(_config__WEBPACK_IMPORTED_MODULE_15__/* .DISCORD.server.mataverseDigital.id */ .qs.server.mataverseDigital.id, _config__WEBPACK_IMPORTED_MODULE_15__/* .DISCORD.server.mataverseDigital.channelId.midjourneyBot */ .qs.server.mataverseDigital.channelId.midjourneyBot));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: title !== null && title !== void 0 ? title : "",
        metadataItems: seoMetadataItemsCollection,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_sections_landing_Shares__WEBPACK_IMPORTED_MODULE_10__/* .RootStyle */ .i, {
            theme: theme,
            backgroundColor: "",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledCard, {
                    sx: {
                        p: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                            sx: {
                                mb: 3
                            },
                            color: "primary",
                            variant: "h3",
                            children: "Line Sticker Generator"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Typewriter__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            hideCursor: true,
                            styleOverPropsForText: {
                                sx: {
                                    color: "common.white"
                                },
                                variant: "body1"
                            },
                            input: "Make money confidently using the Line Sticker Generator. With a user-friendly interface design, you can design unique, fun stickers quickly and generate steady revenue from your creative work! Try it now to make money and have fun with your designs."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP, {
                            container: true,
                            spacing: 4,
                            sx: {
                                pt: 4,
                                pb: 5
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                        disablePortal: true,
                                        freeSolo: true,
                                        id: "character",
                                        inputValue: character,
                                        options: (0,ts_enum_util__WEBPACK_IMPORTED_MODULE_8__/* .$enum */ .o6)(Character).getValues(),
                                        fullWidth: true,
                                        renderInput: function(params) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)({}, params), {
                                                label: "Character to generate",
                                                helperText: "Please choose one or typing your own"
                                            }));
                                        },
                                        onInputChange: function(_event, values) {
                                            return setCharacter(values);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                                        variant: "outlined",
                                        fullWidth: true,
                                        size: "large",
                                        loading: visitorGeneratePromptLazyQueryLoading,
                                        disabled: !character,
                                        onClick: handleGeneratePrompt,
                                        children: "Generate"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    children: visitorGeneratePromptLazyQueryData && renderText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                                fullWidth: true,
                                                multiline: true,
                                                maxRows: 15,
                                                value: (ref2 = originTextInputs !== null && originTextInputs !== void 0 ? originTextInputs : mergedTextInputs) === null || ref2 === void 0 ? void 0 : ref2.join("\r\n"),
                                                onChange: function(event) {
                                                    setOriginTextInputs(event.target.value.split(/\r?\n|\r|\n/g));
                                                    setTextInputs(event.target.value.split(/\r?\n|\r|\n/g));
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                                variant: "outlined",
                                                fullWidth: true,
                                                sx: {
                                                    mt: 3
                                                },
                                                size: "large",
                                                onClick: function() {
                                                    return handleOpenMidjourneyBotChannel();
                                                },
                                                children: "Midjourney Channel"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                                                sx: {
                                                    mt: 3
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                                    variant: "h6",
                                                    children: "Copy and paste to Midjourney AI"
                                                })
                                            }),
                                            mergedTextInputs && (mergedTextInputs === null || mergedTextInputs === void 0 ? void 0 : mergedTextInputs.map(function(textInput, index) {
                                                var ref;
                                                var generateImageCommand = "/imagine prompt:";
                                                var imagesPageSearch = (ref = textInput.split(generateImageCommand)[1]) === null || ref === void 0 ? void 0 : ref.trim();
                                                if ((imagesPageSearch === null || imagesPageSearch === void 0 ? void 0 : imagesPageSearch.slice(-1)) === ".") {
                                                    imagesPageSearch = imagesPageSearch.slice(0, -1);
                                                }
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                    children: textInput.trim() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CopyClipboard__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                                shareInputValue: textInput,
                                                                inputProps: {
                                                                    sx: {
                                                                        mt: 3
                                                                    }
                                                                },
                                                                onShareInputValueChange: function(val) {
                                                                    setOriginTextInputs(function(prev) {
                                                                        if (!prev) {
                                                                            prev = mergedTextInputs;
                                                                        }
                                                                        var shallowCloneTextInputs = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z)(prev);
                                                                        shallowCloneTextInputs[index] = val;
                                                                        return shallowCloneTextInputs;
                                                                    });
                                                                }
                                                            }, textInput),
                                                            imagesPageSearch && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z, {
                                                                direction: "row",
                                                                spacing: 3,
                                                                sx: {
                                                                    mt: 1
                                                                },
                                                                justifyContent: "space-between",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z, {
                                                                        href: "".concat(_routes_paths__WEBPACK_IMPORTED_MODULE_12__/* .PATH_APP_SERVICES.midjourneyImageCollection */ .lO.midjourneyImageCollection, "?search=").concat(imagesPageSearch),
                                                                        target: "_blank",
                                                                        rel: "noopener",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                                                            variant: "outlined",
                                                                            fullWidth: true,
                                                                            size: "large",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                                                                variant: "subtitle1",
                                                                                children: "Search for images related to this prompt"
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_14__.CopyToClipboard, {
                                                                        text: "".concat(generateImageCommand, " ").concat(imagesPageSearch),
                                                                        onCopy: function() {
                                                                            handleOpenMidjourneyBotChannel();
                                                                        },
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                                                            variant: "outlined",
                                                                            size: "large",
                                                                            children: "Copy And Go"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                });
                                            })),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                                                variant: "outlined",
                                                fullWidth: true,
                                                size: "large",
                                                sx: {
                                                    mt: 5
                                                },
                                                onClick: function() {
                                                    return router.push(_routes_paths__WEBPACK_IMPORTED_MODULE_12__/* .PATH_APP_SERVICES.midjourneyImageCollection */ .lO.midjourneyImageCollection);
                                                },
                                                children: "Find your AI masterpieces after generation"
                                            })
                                        ]
                                    })
                                }),
                                promptUsages.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP, {
                                    item: true,
                                    xs: 12,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
                                            sx: {
                                                my: 3
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                            sx: {
                                                mb: 3
                                            },
                                            color: "primary",
                                            variant: "h4",
                                            children: "Latest Generated Prompts"
                                        }),
                                        promptUsages.map(function(promptUsage) {
                                            var ref, ref1, ref2;
                                            return ((ref = promptUsage.response.choices[0]) === null || ref === void 0 ? void 0 : ref.text) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z, {
                                                mb: 4,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                                        variant: "body2",
                                                        mb: 1,
                                                        children: [
                                                            "Character: ",
                                                            promptUsage.userPrompt
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_CopyClipboard__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                        shareInputValue: (ref1 = promptUsage.response.choices[0]) === null || ref1 === void 0 ? void 0 : ref1.text
                                                    }, (ref2 = promptUsage.response.choices[0]) === null || ref2 === void 0 ? void 0 : ref2.text)
                                                ]
                                            }, promptUsage.id) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}


/***/ }),

/***/ 29608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ RootStyle; },
/* harmony export */   "k": function() { return /* binding */ TopLandingSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_animate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76843);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40549);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15861);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32970);







var TopLandingSection = function(props) {
    var _title = props.title, title = _title === void 0 ? "" : _title, titleColor = props.titleColor, _subtitle = props.subtitle, subtitle = _subtitle === void 0 ? "" : _subtitle, subtitleColor = props.subtitleColor, subtitleFontSize = props.subtitleFontSize;
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    if (title === "" && subtitle === "") return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            textAlign: "center",
            mb: 5
        },
        id: title,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__.m.div, {
                variants: (0,_components_animate__WEBPACK_IMPORTED_MODULE_1__/* .varFade */ .EU)().inUp,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    variant: "h3",
                    sx: {
                        mb: 2,
                        color: titleColor !== null && titleColor !== void 0 ? titleColor : theme.palette.primary.main
                    },
                    children: title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__.m.div, {
                variants: (0,_components_animate__WEBPACK_IMPORTED_MODULE_1__/* .varFade */ .EU)().inDown,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    variant: "body1",
                    sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        mb: 2,
                        color: subtitleColor !== null && subtitleColor !== void 0 ? subtitleColor : theme.palette.grey[600]
                    }, subtitleFontSize ? {
                        fontSize: subtitleFontSize
                    } : {}),
                    children: subtitle
                })
            })
        ]
    });
};
var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme, backgroundColor = param.backgroundColor, backgroundImage = param.backgroundImage;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        backgroundColor: backgroundColor || theme.palette.background.neutral,
        backgroundImage: backgroundImage,
        padding: theme.spacing(10, 2)
    }, theme.breakpoints.up("md"), {
        padding: theme.spacing(12, 0)
    });
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6547,513,9694,1664,9463,7952,4894,1997,6993,2,8424,6755,3907,2575,9774,2888,179], function() { return __webpack_exec__(93721); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);